import { createSlice } from "@reduxjs/toolkit";
import { fetchTeachersForCWSNComputerData } from "../thunks/dashboardThunk"; 

const dashboardTeacherTrainedCWSNState = createSlice({
  name: "TeacherTrainedCWSNStats",
  initialState: {
    data: {
      data:[],
      statusCode:0,
      message:"",
      success:false
    },
    
    isLoading:false,
    isError:false
  },

  
  reducers: {},
  extraReducers: (builder) => {
    
    builder
      .addCase(fetchTeachersForCWSNComputerData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchTeachersForCWSNComputerData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data===""?[]:action.payload;
        
      })
      .addCase(fetchTeachersForCWSNComputerData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      
  },
});

export default dashboardTeacherTrainedCWSNState.reducer;